import { render } from "./CurrencyInput.vue?vue&type=template&id=2dc8c395&scoped=true&ts=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts"

import "./CurrencyInput.vue?vue&type=style&index=0&id=2dc8c395&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc8c395"]])

export default __exports__